import React from 'react';
import { useTranslation } from 'react-i18next';
import emailErrorImage from '../../../../assets/images/graphics/email-error.svg';
import { AUTH_KEYS, NS } from '../../../../i18n/constants/keys';
import styles from '../../verify_email.module.css';

export const FailureNotice = () => {
  const { t } = useTranslation(NS.auth);

  return (
    <div
        className={styles.noticeContainer}
    >
      <img
          src={emailErrorImage}
          alt='email-verify'
          width='250px'
      />
      <h1
          className={styles.verificationNoticeHeader}
      >
        { t(AUTH_KEYS.verifyEmail.failedTitle) }
      </h1>
      <p
          className={styles.verificationNoticeInfo}
      >
        { t(AUTH_KEYS.verifyEmail.failedMessage) }
      </p>
    </div>
  );
};
